import{SEARCH_PATH}from"../constants";/**
 * Generate product route for navigation.
 * @param {string} query search term
 * @returns {string}
 */export var getSearchRoute=function getSearchRoute(query){return"".concat(SEARCH_PATH,"?s=").concat(encodeURIComponent(query));};